
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { BaseSyntheticEvent, useId, useRef, useState } from 'react'
import { showMessage } from '../utils/messages'
import { Combobox, CustomTable, InputDate, Modal } from 'medere-ui-framework'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { getAllAccountings, getAllAccountingsPeriod, registerMonthAccounting } from '../servicesHooks/Accounting/useAccountingService'
import { Column } from 'primereact/column'
import { Accounting } from '../interface/interface'

function CloseMonth() {
    const tableRef: any = useRef(null)
    const toast = useRef(null)
    const today = new Date()
    const [closeDate, setCloseDate] = useState(null)
    const [accounting, setAccounting] = useState<Accounting>(null)
    const [infoModal, setInfoModal] = useState(false)

    function handleClick() {
        registerMonthAccounting({ closingDate: closeDate, accountingId: accounting.accounting}).then(() => {
            showMessage(toast, 'Cierre de mes', 'success')
            setInfoModal(false)
            tableRef.current?.refreshTable()
        }).catch((err) => {
            if (err.response.status === 409) {
                showMessage(toast, 'La fecha de cierre no puede ser menor o igual a la fecha de cierre del ultimo periodo', 'error')
            } else {
                showMessage(toast, 'Cierre de mes', 'error')
            }
            setInfoModal(false)

        })
    }

    return (
        <div className='p-4 flex flex-column viewContainer'>
            <h2 className='text-2xl'>Cierre de mes</h2>
            <div className='flex align-items-end justify-content-between'>
                <div className='flex align-items-end gap-4'>
                    <Combobox
                        getItems={getAllAccountings}
                        setValue={setAccounting}
                        value={accounting}
                        optionLabel='description'
                        label='Plan de cuentas'
                    />
                    <InputDate value={closeDate} label='Fecha de cierre' onChange={(e: BaseSyntheticEvent) => {
                        setCloseDate(e.target.value)
                    }}
                        maxDate={today}
                    />
                </div>

                <Button label='Cerrar' className='buttonMain'
                    onClick={() => setInfoModal(true)}
                    disabled={!closeDate}
                />
            </div>
            <h2 className='subTitle'>Cierres previos</h2>
            <CustomTable
                idTable={useId()}
                showGridlines
                hideFiltersButton
                getItems={getAllAccountingsPeriod}
                ref={tableRef}
            >
                <Column field='closingdate' header='Cierre' body={(e) => {
                    return format(new Date(e.closingdate), 'PPP', { locale: es })
                }} />
                <Column field='_username' header='Responsable' />
            </CustomTable>
            <Toast ref={toast} position='bottom-right' />
            <Modal
                visible={infoModal}
                setVisible={setInfoModal}
                header='⚠️ Atención'
                footerButtonRightText='Si'
                onClickRightBtn={handleClick}
            >
                {closeDate && <p>Desea cerrar el mes, el {format(closeDate, 'PPP', { locale: es })}?</p>}

            </Modal>
        </div>
    )
}

export default CloseMonth
